import { isNil } from '@lucidlink/tscore';
export const metricToString = (value) => {
    if (isNil(value)) {
        return 'null';
    }
    if (typeof value === 'number') {
        return value.toFixed();
    }
    if (value instanceof Date) {
        return value.toLocaleString();
    }
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    return value.toString();
};
